import React from 'react';
import { createRoot } from 'react-dom/client';
import WishlistPage from './components/WishlistPage';

// Initialize wishlist page when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('df-wishlist-root');
    if (container) {
        const root = createRoot(container);
        root.render(<WishlistPage />);
    }
});
